import { render, staticRenderFns } from "./2FA.vue?vue&type=template&id=517b5fe5&"
import script from "./2FA.vue?vue&type=script&lang=js&"
export * from "./2FA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports